<template>
  <section>
    <div class="cartList">
      <div>
        <img
          v-if="!item.image"
          class="cartListImg"
          src="../../../assets/images/default-img.jpg"
        />

        <img v-else class="cartListImg" :src="item.image" :alt="item.name" />
      </div>
      <div class="cartListInfo">
        <div class="cartListInfo-top">
          <p>{{ item.name }}</p>
        </div>
        <div class="cartListInfo-bottom">
          <p class="price">NRs. {{ item.after_price }}</p>

          <div class="add-wrapper" v-if="!add">
            <div class="add" @click="addToCartCall(item)">ADD</div>
          </div>

          <div class="qty" v-else>
            <a-icon
              type="minus"
              class="minus"
              icon="minus"
              @click="minusQuantity(item.id)"
            />
            {{ quantity }}
            <a-icon
              type="plus"
              class="plus"
              icon="plus"
              @click="addQuantity(item.id)"
            />
          </div>
          <!-- <p class="total">
                    NRs. {{ item.after_price * item.quantity }}
                  </p> -->
        </div>
      </div>
      <!-- <div class="remove-item">
                <a-popconfirm
                  title="Are you sure delete this item?"
                  @confirm="deleteItem(item.id)"
                  @cancel="cancel"
                  okText="Yes"
                  cancelText="No"
                >
                  <a-icon type="close" class="close" />
                </a-popconfirm>
              </div> -->
      <!-- <a-icon type="close" class="close" /> -->
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { CartData } from "../../../services/storage.service";
import isUrl from "../../../utils/isUrl";

export default {
  name: "SuggestItem",
  props: ["item"],
  data() {
    return {
      add: false,
      quantity: 1,
      itemId: null,
      tags: [],
      imageUrl: false,
    };
  },
  computed: {
    ...mapGetters(["cartItems"]),
  },
  created() {
    this.itemId = this.item.id;

    if (this.item.image !== "") {
      if (isUrl(this.item.image)) {
        this.imageUrl = true;
      }
    }

    let forQty = this.cartItems.filter((food) => food.id === this.item.id);
    this.quantity = forQty[0].quantity;

    if (this.cartItems.filter((food) => food.id === this.item.id).length > 0) {
      this.add = true;
    }

    let itemtags = this.item.tags.split(",");
    this.tags = itemtags.filter((data) => data);
  },
  watch: {
    // whenever question changes, this function will run
    cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
      if (newCartItems.length === 0) {
        this.add = false;
        this.quantity = 1;
        return;
      } else if (
        newCartItems.filter((food) => food.id === this.itemId).length === 0
      ) {
        this.add = false;
        this.quantity = 1;
        return;
      } else {
        this.quantity = newCartItems.filter(
          (food) => food.id === this.itemId
        )[0].quantity;
      }
    },
  },

  methods: {
    ...mapActions(["addToCart", "addQuantity", "minusQuantity"]),

    addToCartCall(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
  },
};
</script>


<style lang="scss" scoped>
// new css
// variables
$theme-color: #ed2027;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

.cartList {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 0;
  border-radius: $border-radius;
  // margin: 10px 0 -10px;
  img {
    height: 60px;
    width: 60px;
    border-radius: $border-radius;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }
  .cartListInfo {
    margin: 0 60px 0 30px;
    flex-basis: 80%;
    display: flex;
    flex-flow: column nowrap;
    .cartListInfo-top {
      p {
        font-size: $text-size;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
    .cartListInfo-bottom {
      display: flex;
      justify-content: space-between;
      .qty {
        border: $border;
        border-radius: $border-radius;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .minus {
          margin: 0 15px 0 10px;
          color: $font-color;
          &:hover {
            cursor: pointer;
          }
        }
        .plus {
          color: $success-color;
          margin: 0 10px 0 15px;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .total {
        font-weight: bold;
      }
    }
  }
  .close {
    color: $theme-color;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
    &:hover {
      text-shadow: none;
      cursor: pointer;
      transition: all ease-in-out 0.3s;
      opacity: 0.8;
    }
  }
}

section {
  padding: 0 !important;
}

.add-wrapper {
  border: $border;
  border-radius: $border-radius;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
}

.add {
  font-size: 14px;
  padding: 10px;
  color: $font-color;
  text-align: center;
  align-self: center;
}
</style>